enum PressReleaseInviteActionType {
	POST_PRESS_RELEASE_GUEST_USER_REQUEST = "POST_PRESS_RELEASE_GUEST_USER_REQUEST",
	POST_PRESS_RELEASE_GUEST_USER_SUCCEEDED = "POST_PRESS_RELEASE_GUEST_USER_SUCCEEDED",
	POST_PRESS_RELEASE_GUEST_USER_FAILED = "POST_PRESS_RELEASE_GUEST_USER_FAILED",
}

export default PressReleaseInviteActionType

